// ─── SCROLL REVEAL ────────────────────────────────────────────
// Muestra los elementos .reveal al entrar al viewport. Respeta
// prefers-reduced-motion y degrada si no hay IntersectionObserver.
(() => {
  "use strict";

  const reveals = document.querySelectorAll(".reveal");
  if (!reveals.length) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion || !("IntersectionObserver" in window)) {
    reveals.forEach((el) => el.classList.add("visible"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("visible");
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12 }
  );

  reveals.forEach((el) => observer.observe(el));
})();
